import { Component, Vue } from 'vue-property-decorator'
import { getAllocationStudentList, claimStudent } from '@/api'
import HighFilter from '@/components/highFilter/index.vue'

@Component({ name: 'receive-list-page', components: { HighFilter } })
export default class ReceiveListPage extends Vue {
  private loading = false
  private receiveDialog = false // 认领弹窗
  private dataType = 1 // 1 - 待分配 2 - 已分配
  private totalPage = 1;
  private currentPage = 1;
  private groupChooseList = []
  private tableData = []
  private filterData: any = {};
  private filterResult: any = null
  private showHighFilter = false
  created () {
    this.initPageData()
  }

  private async initPageData () {
    this.loading = true
    const param: any = { isClaim: this.dataType === 2, page: this.currentPage, limit: 20 }
    if (this.filterResult) {
      param.search = this.filterResult
    }
    const result: any = await getAllocationStudentList(param)
    const { allPage, currentPage, studentList, search } = result
    this.currentPage = currentPage
    this.totalPage = allPage
    this.tableData = studentList
    this.filterData = search
    this.loading = false
  }

  private async onFilterResult (data: any) {
    this.filterResult = data
    this.currentPage = 1
    await this.initPageData()
    this.showHighFilter = false
  }

  /**
   * [description] 分页切换回调函数
   */
  private onPageChange () {
    this.initPageData()
  }

  /**
   * [description] 认领
   */
  private async onActionClick (data: any) {
    await claimStudent({ students: [{ studentId: [data.id], classId: data.classId }] })
    this.receiveDialog = true
    this.initPageData()
  }

  private onTypeChange (type: any) {
    this.dataType = type
    // 切换以后 需要把当前页标记归位
    this.currentPage = 1
    this.initPageData()
  }

  /**
   * [description] 批量认领
   */
  private async onGroupAllocationClick () {
    await claimStudent({ students: this.groupChooseList })
    this.receiveDialog = true
    await this.initPageData()
  }

  private groupChoose (data: any) {
    this.groupChooseList = data.map((item: any) => { return { studentId: [item.id], classId: item.classId } })
  }

  /**
   * [description] 表格的某一行被点击
   */
  private tableRowClick (row: any, column: any) {
    this.$router.push({ path: '/student/detail', query: { id: row.id, sellOrderId: row.sellOrderId } })
  }
}
